import React from 'react';
import PropTypes from 'prop-types';
import useBranch from 'client/hooks/useBranch';

import SrCard from 'client/components/SrCard/SrCard';
import SrLinkUrlButton from 'client/components/SrLinkUrlButton';

import './UPActivationLink.less';
import { isHomebuyerPartner } from 'common/utility/helpers';

const UPActivationLink = ({ utilityPartner, maxWidth = 'unset' }) => {
  const { utilityAppUrl } = useBranch({ utilityAppUrl: ['env', 'UTILITY_APP_URL'] });
  return (
    <SrCard maxWidth={maxWidth} padding="24px 24px 34px" margin="0 0 32px">
      <div styleName="containerBox">
        <div styleName="contentBox">
          <div styleName="titleBox">
            {isHomebuyerPartner(utilityPartner) ? (
              <span styleName="titleText">
                Share this link with your clients to streamline their utility setup.
              </span>
            ) : (
              <span styleName="titleText">
                Send this link to any tenant <br />
                so they can
                <span styleName="titleText green">{' activate utilities.'}</span>
              </span>
            )}
          </div>
          <SrLinkUrlButton
            buttonText="Copy Link"
            href={`${utilityAppUrl}/${utilityPartner.slug}`}
          />
        </div>
      </div>
    </SrCard>
  );
};

UPActivationLink.propTypes = {
  maxWidth: PropTypes.string,
  utilityPartner: PropTypes.object.isRequired,
};

UPActivationLink.displayName = 'UPActivationLink';

export default UPActivationLink;
